// Transaction: {
//  type: 'free_credits' | 'purchased_credits' | 'profile_unlock' | 'essay_review'
//  descriptor: 'bonus' | 'free_trial' | '5' | '15' | '50' | string
//  value: number
//  timestamp: Date
//}

// Transaction "type"
export const FREE_CREDITS = "free_credits";
export const PURCHASED_CREDITS = "purchased_credits";
export const PROFILE_UNLOCK = "profile_unlock";
export const ESSAY_REVIEW = "essay_review";
export const RETURNED_CREDITS = "returned_credits";

// Transaction "descriptor"
export const BONUS = "bonus";
export const AFFILIATE = "affiliate";
export const ADMIN_ADDED_CREDITS = "admin_added_credits";
export const PROMO_CODE = "promo_code";
export const ESSAY_PASS = "essay_pass";

export const hasEnoughCredits = (
  userData,
  amount,
  preferBonusCredits = false,
  isEnterprise = false
) => {
  if (!userData) {
    throw new Error("User not found!");
  }

  if (isEnterprise) {
    const credits = userData.enterprise_unlocks || 0;

    const totalCredits = credits;

    return amount <= totalCredits;
  } else {
    const credits = userData.credits || 0;
    const bonusCredits = userData.bonusCredits || 0;

    const totalCredits = preferBonusCredits ? credits + bonusCredits : credits;

    return amount <= totalCredits;
  }
};

export const subtractCredits = (
  userData,
  amount,
  preferBonusCredits = false,
  isEnterprise = false
) => {
  if (!userData) {
    throw new Error("User not found!");
  }

  if (isEnterprise) {
    const credits = userData.enterprise_unlocks || 0;

    let remainingAmount = amount;

    let remainingCredits = credits;

    let creditsRemoved = 0;

    if (remainingAmount > 0) {
      creditsRemoved = remainingAmount;
      remainingCredits -= creditsRemoved;
    }

    return {
      remainingCredits,
      creditsRemoved,
    };
  } else {
    const credits = userData.credits || 0;
    const bonusCredits = userData.bonusCredits || 0;

    let remainingAmount = amount;
    let remainingBonusCredits = bonusCredits;
    let remainingCredits = credits;

    let bonusCreditsRemoved = 0;
    let creditsRemoved = 0;

    if (preferBonusCredits) {
      bonusCreditsRemoved = Math.min(remainingBonusCredits, remainingAmount);
      remainingBonusCredits -= bonusCreditsRemoved;
      remainingAmount -= bonusCreditsRemoved;
    }

    if (remainingAmount > 0) {
      creditsRemoved = remainingAmount;
      remainingCredits -= creditsRemoved;
    }

    return {
      remainingBonusCredits,
      remainingCredits,
      bonusCreditsRemoved,
      creditsRemoved,
    };
  }
};
